<template>
    <v-toolbar
        class="elevation-10 kim-toolbar"
        color="white"
        fixed
        scroll-off-screen
        :scroll-threshold="100"
    >
        <v-btn
            fab
            flat
            :disabled="!isOnBoardingDone"
            color="primary"
            @click.stop="$emit('click:menu')"
        >
            <v-icon size="22">mdi-menu</v-icon>
        </v-btn>
        <img
            alt="kim-logo"
            height="53"
            src="@/assets/img/logo.png"
        />
        <v-spacer></v-spacer>
        <v-chip small outline color="error" v-if="daysToExpire">
            {{ daysToExpire }}
        </v-chip>
        <v-toolbar-items>
            <account-picker-btn v-if="showBranchOfficePicker"/>
            <account-menu-button :hideOnMobile="false" color="primary"></account-menu-button>
        </v-toolbar-items>

    </v-toolbar>
</template>

<script>
import AccountMenuButton from '../../../components/account/AccountMenuButton'
import KimsaDrawer from '@/components/common/panel/KimsaDrawer'
import AccountPickerBtn from "../../../components/common/panel/AccountPickerBtn";
import {mapGetters, mapState} from 'vuex';
import OfferListItem from "../../providers/quotations/OfferListItem";
import OnlineWatcher from "../OnlineWatcher";

export default {
    props: [],
    components: {
        OnlineWatcher,
        OfferListItem,
        AccountPickerBtn,
        AccountMenuButton,
        KimsaDrawer
    },
    data() {
        return {
            showDrawer: false
        }
    },
    computed: {
        ...mapState(['currentProvider']),
        ...mapGetters(['trialIsExpired']),
        showBranchOfficePicker() {
            const vm = this
            if (!vm.$route.meta || vm.$route.meta.showBranchOfficePicker === undefined) {
                return true
            }

            return vm.$route.meta.showBranchOfficePicker

        },
        daysToExpire() {
            const vm = this
            if (!vm.currentProvider || !vm.currentProvider.trial_expires_at || vm.trialIsExpired) {
                return null
            }

            const now = vm.$moment();
            const trialEpiresAt = vm.$moment(vm.currentProvider.trial_expires_at)
            let daysToExpire = trialEpiresAt.diff(now, 'days')
            if(daysToExpire === 0) return '¡la prueba termina hoy!'
            if(daysToExpire > 0) return `quedan ${daysToExpire} días de prueba`
            return null

        }
    },
    methods: {
        onDrawerChange(val) {
            this.showDrawer = val
        }
    }
}

</script>

<style scoped>
.kim-toolbar {
    font-family: Roboto, sans-serif;
    background-color: rgba(255, 255, 255, .95) !important;
}
</style>